var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 3.0625H12.2695L11.0742 1.09375C10.793 0.636719 10.1602 0.25 9.63281 0.25H6.08203C5.55469 0.25 4.92188 0.636719 4.64062 1.09375L3.44531 3.0625H0.5625C0.246094 3.0625 0 3.34375 0 3.625V4.1875C0 4.50391 0.246094 4.75 0.5625 4.75H1.125L1.86328 16.668C1.89844 17.5469 2.67188 18.25 3.55078 18.25H12.1641C13.043 18.25 13.8164 17.5469 13.8516 16.668L14.625 4.75H15.1875C15.4688 4.75 15.75 4.50391 15.75 4.1875V3.625C15.75 3.34375 15.4688 3.0625 15.1875 3.0625ZM6.08203 1.9375H9.63281L10.3008 3.0625H5.41406L6.08203 1.9375ZM12.1641 16.5625H3.55078L2.8125 4.75H12.9023L12.1641 16.5625Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.a306420a.svg";
export { ForwardRef as ReactComponent };